module.exports = __webpack_public_path__ + "static/media/sms.18a28a12.svg";